// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__anuoF","clinicsSelect":"TableHeading_clinicsSelect__dMPlA"};